module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAANtJREFUKBVjZACCUwY6m/8zMPiA2MQCJpDC/2zMxQyMjN+J1QRSB9ZofuriLSYGxmRGoBnEagZrBCk2PX9pOdCcMmI1Ai1BBacM9Er+M/zrRhXF5GFoBCk5baSb/f/f/8lAd2OVB6nBKXHaUC/kH8O/xUBfc4AUogOcGkEKTxrqWjIy/N/0/z+DCLpGeOCgS4D45ucvH2dkYTRnZGC8gi6PVyNIsenpy/e4BYSBNjOuR9aM16nICv///894xlC3Dhhg9aBAI1ojzJDTBrpe/xj+L4bxSaLPGRrKAwCs1TVCykAB5gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/images/corners/absent-icon.png
// module id = ../../../../../src/assets/images/corners/absent-icon.png
// module chunks = main